import jobQueries from "$/lib/queries/job-queries"
import { createFileRoute } from "@tanstack/react-router"
import { fallback, zodValidator } from "@tanstack/zod-adapter"
import { z } from "zod"
import { ensureJobStoreSelected } from "../../-utils/ensure-job-store-selected"

const searchSchema = z.object({
  customerName: fallback(z.string(), "").default(""),
})

const paramsSchema = z.object({
  jobId: z.string().uuid(),
})

export const Route = createFileRoute("/(app)/_auth/messages/$jobId")({
  params: {
    parse: (params) => paramsSchema.parse(params),
    stringify: ({ jobId }) => ({ jobId: `${jobId}` }),
  },
  validateSearch: zodValidator(searchSchema),
  beforeLoad: ({ context: { queryClient }, params, preload }) =>
    ensureJobStoreSelected(queryClient, params.jobId, preload),
  loaderDeps: ({ search }) => ({
    customerName: search.customerName,
  }),
  loader: async ({ context: { queryClient }, params, deps }) => {
    queryClient.ensureQueryData(jobQueries.detail(params.jobId))

    return { crumb: deps.customerName }
  },
})
